(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('MateriaSearch', MateriaSearch);

    MateriaSearch.$inject = ['$resource'];

    function MateriaSearch($resource) {
        var resourceUrl =  'api/_search/materias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
